import React, { Suspense, lazy, type ComponentProps } from 'react';
import type { Document as PdfDocument, Page as PdfPage } from 'react-pdf';

const loadPdf = () => import('./pdf-inner');

const InnerDocument = lazy(() => loadPdf().then((m) => ({ default: m.Document })));
const InnerPage = lazy(() => loadPdf().then((m) => ({ default: m.Page })));

type DocumentProps = ComponentProps<typeof PdfDocument>;
type PageProps = ComponentProps<typeof PdfPage>;

export function Document(props: DocumentProps) {
  const fallback = React.isValidElement(props.loading) ? props.loading : null;
  return (
    <Suspense fallback={fallback}>
      <InnerDocument {...props} />
    </Suspense>
  );
}

export function Page(props: PageProps) {
  return <InnerPage {...props} />;
}
